
<template>
  <transition name="fade-slide">
    <div
      v-if="show"
      class="alert alert-dismissible fade show font-weight-light position-fixed shadow-lg d-flex align-items-center justify-content-between"
      :class="alertData.bgColor"
      style="top: 3rem; right: 1rem; z-index: 1050; min-width: 300px;"
      role="alert"
    >
      <div class="alert-content">
        <span class="alert-icon">
          <span class="material-symbols-rounded">{{ alertData.icon }}</span>
        </span>
        <span class="alert-text">{{ alertData.message }}</span>
      </div>

      <button
        type="button"
        class="btn-close d-flex justify-content-center align-items-center ms-2"
        @click="hideAlert"
        aria-label="Close"
      >
        <span aria-hidden="true" class="text-lg font-weight-bold">×</span>
      </button>
    </div>
  </transition>
</template>

<script>
import emitter from "@/utils/emitter";
export default {
  name: "GlobalAlert",
  props: {
    message: {
      type: String,
      required: false,
      default: ""
    },
    bgColor: {
      type: String,
      default: "alert-primary"
    },
    icon: {
      type: String,
      default: "error"
    },
    duration: {
      type: Number,
      default: 5000
    }
  },
  data() {
    return {
      show: false,
      timeoutId: null,
      alertData: {
        message: "",
        bgColor: "alert-primary",
        icon: "error",
        duration: 5000
      }
    };
  },
  mounted() {
    emitter.on("trigger-error", this.showAlert);
  },
  beforeUnmount() {
    emitter.off("trigger-error", this.showAlert);
  },
  methods: {
    showAlert(payload) {
      this.alertData = {
        message: payload.message,
        bgColor: payload.bgColor || "alert-primary",
        icon: payload.icon || "error",        
        duration: payload.duration ?? payload.time ?? 5000
      };

      this.show = true;
      this.setAutoHide();
    },
    hideAlert() {
      this.show = false;
      this.$emit("close");
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    },
    setAutoHide() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }

      if (this.alertData.duration !== null) {
        this.timeoutId = setTimeout(() => {
          this.hideAlert();
        }, this.alertData.duration);
      }
    }
  },
  computed: {

  }
};
</script>

<style scoped>
/* Transition and fade styles */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 1s ease; /* Slow down the transition to 1 second */
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.fade-slide-enter-to,
.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
}

/* Smooth fade-out transition */
.alert {
  transition: opacity 0.5s ease; /* Slow down the fade-out to 0.5 seconds */
}

/* Flex container for icon and message */
.alert-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.alert-primary {
  color: #084298;             /* Text color */
  background-color: #cfe2ff;  /* Light blue background */
  border: 1px solid #b6d4fe;  /* Border matching the tone */
  border-radius: 0.375rem;      /* Rounded corners */
}

.alert-danger {
  color: white;              /* Text color */
  background-color: #f8d7da;  /* Light red background */
  border: 1px solid #f5c2c7;  /* Border matching the tone */
  border-radius: 0.375rem;      /* Rounded corners */
}

.alert-success {
  color: white;                /* Dark green text */
  background-color: #d1e7dd;     /* Light green background */
  border: 1px solid #badbcc;     /* Soft green border */
  border-radius: 0.375rem;       /* Rounded corners */
}

/* Material icon styling */
.material-symbols-rounded {
  font-size: 20px;
  line-height: 1;
  vertical-align: middle;
}
</style>